<template>
    <g class="label-group"
       :class="labelClass()"
       @mouseenter="$emit('hover')"
       @mouseleave="stopDragDelay"
       @mousedown="startDrag($event)"
       @mouseup="stopDrag()"
       @click="$emit('select')"
       @dblclick.stop="$emit('edit')"
       ref="label-hotspots"
    >
        <circle class="label-drag-circle"
                :cy="labelPositionY()"
                :cx="labelPositionX()"
                r="1"
        />
        <circle
                class="label-hotspots-border"
                :cy="labelPositionY()"
                :cx="labelPositionX()"
                r="14"
                :style="labelStrokeStyle()"
        />
        <circle
                class="label-hotspots-extraborder"
                :cy="labelPositionY()"
                :cx="labelPositionX()"
                r="17"
        />
        <circle class="label-hotspots-center"
                :cy="labelPositionY()"
                :cx="labelPositionX()"
                r="2"
                :style="labelFillStyle()+labelStrokeStyle()"
        />
    </g>
</template>

<script>
    import Tools from "../../class/tools";
    import events from "@/events/events";

    export default {
        name: "Hotsports_Pointer",
        props:{
            label:{},
            imageData:{type:Object},
            selected:{type:Boolean},
            hovered:{type:Boolean}
        },
        data(){
            return{
                start:false,
                drag:false,
                dragMove:false,
                dragOffset :{
                    x:0,
                    y:0
                },
                editColor:false
            }
        },
        methods:{
            startDrag($event) {
                this.start = true;
                setTimeout(() => {
                    if (this.start) {
                        this.drag = true;

                        this.dragOffset.x = $event.pageX - this.$refs["label-hotspots"].getBoundingClientRect().left - 15;
                        this.dragOffset.y = $event.pageY - this.$refs["label-hotspots"].getBoundingClientRect().top - 15;

                        this.$emit('select');
                        this.$emit('drag');
                        events.$on("body:click:mouse:up",this.stopDrag)
                    }
                }, this.$store.getters.getDelayBeforeDrag)
            },
            stopDrag() {
                this.start = false;
                
                if(this.dragMove) {
                    this.label.save();
                }
                
                this.dragMove = false;
                this.drag = false;
                this.$emit('undrag');
                events.$off("body:click:mouse:up",this.stopDrag)
    
            },
            stopDragDelay(){
                if(this.start && !this.drag){
                    this.start = false;
                    this.drag = false;
                }
                if(!this.drag){
                    this.$emit('unhover')
                }
            },
            labelClass() {

                let classe = this.label.getObjectType();
                if (this.start) {
                    classe += " start ";
                }
                if (this.drag) {
                    classe += " drag ";
                }
                if (this.selected) {
                    classe += " select ";
                }
                if (this.hovered) {
                    classe += " hover ";
                }

                return classe
            },
            labelPositionX(){
                let x = parseFloat(this.label.x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionY(){
                let y = parseFloat(this.label.y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            labelFillStyle(){
                if(this.selected && !this.editColor) return"";
                return 'fill:'+this.label.label_color+";";
            },
            labelStrokeStyle(){
                if(this.selected && !this.editColor) return"";
                return "stroke:"+this.label.label_color
            }
        },
        watch:{
            '$store.state.mouse.position'(value){

                if (!this.drag) return;
                
                let label = this.label;
                label.x_coord = Tools.format(value.x - this.dragOffset.x,-100, this.imageData.width + 100,this.imageData.ratioX);
                label.y_coord = Tools.format(value.y - this.dragOffset.y,-1000, this.imageData.height + 1000,this.imageData.ratioY);
    
                this.dragMove = true;
            },
            'imageData.zoom'(){
                this.$forceUpdate();
            },
            'imageData.width'(){
                this.$forceUpdate();
            },
            'imageData.height'(){
                this.$forceUpdate();
            },
            'label.label_color'(){
                this.editColor = true;
                clearTimeout(this._timeout);
                
                this._timeout = setTimeout(() => {
                    this.editColor = false;
                },1000)
            }
        }
    }
</script>